import React from 'react'
import { useParams } from 'react-router-dom'
import { UnifiedClientProfile } from '../../../components/finance/client-profile/UnifiedClientProfile'

export const ClientProfilePage: React.FC = () => {
  const { clientId } = useParams<{ clientId: string }>()

  if (!clientId) {
    return (
      <div style={{ padding: '32px', textAlign: 'center' }}>
        <p>Client ID is required</p>
      </div>
    )
  }

  return <UnifiedClientProfile clientId={clientId} />
}
